import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    breadList: [],
    activeVal: "0",
    pid: null,
    keyword: ""
  },
  mutations: {
    getbread (state, type) {
      state.breadList = type;
    },
    getactive (state, type) {
      state.activeVal = type;
    },
    getpid (state, type) {
      state.pid = type;
    },
    getkey (state, type) {
      state.keyword = type;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js